import { Injectable } from "@angular/core";
import { StringKeyOf } from "@logex/framework/types";
import { ISimpleOrderBySpecification } from "@logex/framework/lg-pivot";

export interface OrderStorage {
    organizationList: ISimpleOrderBySpecification;
    logs: ISimpleOrderBySpecification;
    affiliationList: ISimpleOrderBySpecification;
}

export type OrderStorageKey = StringKeyOf<OrderStorage>;

@Injectable({ providedIn: "root" })
export class LastOrderStorageService {
    private state: OrderStorage;

    constructor() {
        this.state = {
            organizationList: "",
            logs: "",
            affiliationList: ""
        };
    }

    store(key: OrderStorageKey, currentState: ISimpleOrderBySpecification): void {
        this.state[key] = currentState;
    }

    get(key: OrderStorageKey): ISimpleOrderBySpecification {
        return this.state[key];
    }
}
